import {NgModule} from '@angular/core';
import {ExtraOptions, PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {NoAuthGuard} from "./core/auth/guards/noAuth.guard";
import {AuthenticateComponent} from "./modules/authenticate/authenticate.component";

// Extra Config
const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled'
};

const routes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'authenticate', component: AuthenticateComponent},
  {path: 'login', loadChildren: () => import('./core/login/login.module').then(m => m.LoginModule)},
  {path: 'recovery/:id', loadChildren: () => import('./modules/recovery/recovery.module').then(m => m.RecoveryModule)},
  {path: 'accept-terms/:id', loadChildren: () => import('./modules/accept-terms/accept-terms.module').then(m => m.AcceptTermsModule)},
  {path: 'not-accept-terms/:id', loadChildren: () => import('./modules/accept-terms/accept-terms.module').then(m => m.AcceptTermsModule)},
  {path: 'termination-form-pdf/:id', loadChildren: () => import('./modules/form-pdf/form-pdf.module').then(m => m.FormPdfModule)},
  {path: 'termination-form-pdf-compliance/:id', loadChildren: () => import('./modules/form-pdf/form-pdf.module').then(m => m.FormPdfModule)},
  {path: 'termination-form',loadChildren: () => import('./modules/form-to-colab/form-to-colab.module').then(m => m.FormToColabModule)},
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    loadChildren: () => import('./layout/main/main.module').then(m => m.MainModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerConfig)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
